import exceljs from "exceljs";
import moment from "moment";
import { saveAs } from "file-saver";
import i18n from '@/plugins/vue-i18n';

export class Excel {
  constructor() {
    // excel file type
  }
  static async saveFile(workbook, fileName) {
    const buffer = await workbook.xlsx.writeBuffer();
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const fileExtension = ".xlsx";
    const blob = new Blob([buffer], { type: fileType });
    return saveAs(blob, fileName + fileExtension);
  }
  static async generateExcel(data, startDate, endDate) {
    // console.log(data);
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet(i18n.t('payment.refund_data'));
    worksheet.columns = [
      {
        header: i18n.t('date'),
        key: "a",
        width: 25,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.refund_date'),
        key: "b",
        width: 25,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('customer.title'),
        key: "c",
        width: 25,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.shop_name'),
        key: "d",
        width: 25,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('market.market_title'),
        key: "e",
        width: 25,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.space'),
        key: "f",
        width: 25,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.payment_by_employee'),
        key: "g",
        width: 25,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.total'),
        key: "h",
        width: 25,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.payment_status'),
        key: "i",
        width: 25,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.checkout_status'),
        key: "j",
        width: 25,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      }
    ];
    // add row

    worksheet.getRow(1).font = { bold: true };
    worksheet.getRow(1).alignment = {
      vertical: "middle",
      horizontal: "center"
    };
    // row height
    worksheet.getRow(1).height = 30;
    data.map(async i => {
      await worksheet.addRow(
        {
          a: i.checkOutDate ? new Date(moment(i.checkOutDate).format("YYYY-MM-DD")) : "",
          b: i.payDate ? new Date(moment(i.payDate).format("YYYY-MM-DD")) : "",
          c: i.customerData.name || "-",
          d: i.contract.businessName || "-",
          e: "" + i.areaNameListString + "",
          f: parseFloat(i.areaSum).toFixed(2),
          g: i.getReceivedBy,
          h: parseFloat(i.totalCostAbs).toFixed(2),
          i: i.isPaidClass.text,
          j: i.statusClass.text
        },
        { alignment: { horizontal: "center" } }
      );
      // set center
    });

    const fileToDayDateTime = moment(new Date()).format("YYYYMMDDHHmmss");
    const newStartDate = moment(startDate).format("DD/MM/YYYY");
    const newEndDate = moment(endDate).format("DD/MM/YYYY");
    const formToDate = "from-" + newStartDate + "-to-" + newEndDate;
    // save excel
    return this.saveFile(
      workbook,
      "report-cashback-" + formToDate + "-" + fileToDayDateTime
    );
  }
  static generateExcel2(data, startDate, endDate) {
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet(i18n.t('payment.refund_data'));
    worksheet.columns = [
      {
        header: i18n.t('contract.contract_number_only'),
        width: 17,
        key: "a",
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('date'),
        width: 17,
        key: "b",
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('customer.title'),
        width: 25,
        key: "c",
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.shop_name'),
        width: 25,
        key: "d",
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.number_of_market_area'),
        width: 20,
        key: "e",
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.space'),
        width: 17,
        key: "f",
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('bill.pending_bill'),
        width: 25,
        key: "g",
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.checkout_bill'),
        width: 25,
        key: "h",
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.deposit_money'),
        width: 25,
        key: "i",
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.total'),
        width: 25,
        key: "j",
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.payment_status'),
        width: 25,
        key: "k",
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.payment_or_refund_date'),
        width: 25,
        key: "l",
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },

      {
        header: i18n.t('payment.payment_received_by'),
        width: 25,
        key: "m",
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('contract.checkout_type'),
        width: 25,
        key: "n",
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.checkout_status'),
        width: 25,
        key: "o",
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('note'),
        width: 25,
        key: "p",
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      }
    ];
    // add row
    worksheet.getRow(1).font = { bold: true };
    worksheet.getRow(1).alignment = {
      vertical: "middle",
      horizontal: "center"
    };
    // row height
    worksheet.getRow(1).height = 30;
    data.map(i => {
      worksheet.addRow(
        {
          a: i.contract.contractId,
          b: i.checkOutDate ? new Date(moment(i.checkOutDate).format("YYYY-MM-DD")) : "-",
          c: i.customerData.name,
          d: i.contract.businessName,
          e: i.areas.length,
          f: this.convertThaiCurrency(parseFloat(i.areaSum).toFixed(2)),
          g: this.convertThaiCurrency(parseFloat(i.unpaidTotalCost).toFixed(2)),
          h: this.convertThaiCurrency(
            parseFloat(i.checkOutTotalCost).toFixed(2)
          ),
          i: this.convertThaiCurrency(
            parseFloat(i.depositTotalCost - (i.isForfeit ? i.forfeitCost : 0)).toFixed(2)
          ),
          j: this.convertThaiCurrency(parseFloat(i.totalCostAbs).toFixed(2)),
          k: i.isPaidClass.text,
          l: i.payDate ? new Date(moment(i.payDate).format("YYYY-MM-DD")) : "-",
          m: i.getReceivedBy,
          n: i.checkoutType,
          o: i.statusClass.text,
          p: ''
        },
        { alignment: { horizontal: "center" }, height: 20 }
      );
      i.summary.map(j => {
        worksheet.addRow(
          {
            a: "",
            b: "",
            c: "",
            d: "",
            e: j.area ? j.area.name : j.isForfeit ? i18n.t('payment.forfeit_deposit_money') : i18n.t('other'),
            f: this.convertThaiCurrency(
              parseFloat(j.area ? j.area.size : 0).toFixed(2)
            ),
            g: this.convertThaiCurrency(
              parseFloat(j.unpaidTotalCost).toFixed(2)
            ),
            h: this.convertThaiCurrency(
              parseFloat(j.checkOutTotalCost).toFixed(2)
            ),
            i: this.convertThaiCurrency(
              parseFloat(j.isForfeit ? j.forfeitCost : j.depositTotalCost).toFixed(2)
            ),
            j: this.convertThaiCurrency(
              parseFloat(
                (j.depositTotalCost + j.forfeitCost) - (j.unpaidTotalCost + j.checkOutTotalCost)
              ).toFixed(2)
            ),
            k: "",
            l: "",
            m: "",
            n: "",
            o: "",
            p: j.area ? "" : j.isForfeit ? i.forfeitNote : ""
          },
          { alignment: { horizontal: "center" } }
        );
      });
      // set center
    });
    const newStartDate = moment(startDate).format("DD/MM/YYYY");
    const newEndDate = moment(endDate).format("DD/MM/YYYY");
    const fromToDate = "from-" + newStartDate + "-to-" + newEndDate;
    const fileToDayDateTime = moment(new Date()).format("YYYYMMDDHHmmss");
    // save excel
    this.saveFile(
      workbook,
      "report-checkout-" + fromToDate + "-" + fileToDayDateTime
    );
  }
  static convertThaiCurrency(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  static async reportCheckin(contracts, startDate, endDate, billingSettings, invoices, isActiveContract) {
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet(i18n.t('customer.customer_move_in'));
    worksheet.columns = [
      {
        header: i18n.t('market.market'),
        key: 1,
        width: 25,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('market.market_title'),
        key: 2,
        width: 25,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('market.marchant_name'),
        key: 3,
        width: 25,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('bill.customer_market_id'),
        key: 4,
        width: 25,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('product.title'),
        key: 5,
        width: 25,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.shop_name'),
        key: 6,
        width: 25,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('customer.customer_tel'),
        key: 7,
        width: 25,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.deposit_money'),
        key: 8,
        width: 25,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('contract.start_date'),
        key: 9,
        width: 25,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('contract.end_date'),
        key: 10,
        width: 25,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('contract.contract_number_only'),
        key: 11,
        width: 25,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.rent_and_service_per_month'),
        key: 12,
        width: 25,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },


    ];
    // add row

    worksheet.getRow(1).font = { bold: true };
    worksheet.getRow(1).alignment = {
      vertical: "middle",
      horizontal: "center"
    };
    // row height
    worksheet.getRow(1).height = 30;
    let billingSettingByAreaObject = {}
    let invoiceByContractObject = {}
    for (const invoice of invoices) {
      if (invoice.contract && !invoiceByContractObject[invoice.contract.objectId]) invoiceByContractObject[invoice.contract.objectId] = 0
      invoiceByContractObject[invoice.contract.objectId] += invoice.totalValue
      if (invoice.refInvoiceBooking?.length)
        for (const refInvoiceBooking of invoice.refInvoiceBooking) {
          invoiceByContractObject[invoice.contract.objectId] += refInvoiceBooking.totalValue
        }
    }
    for (let billingSetting of billingSettings) {
      if (billingSetting.type == 'monthly') {
        let total = 0
        let areaId = billingSetting.area.objectId
        if (areaId && !billingSettingByAreaObject[areaId]) billingSettingByAreaObject[areaId] = { data: [], total: 0 }
        total = (parseFloat(billingSetting.cost)) - (parseFloat(billingSetting.originalDiscount))
        billingSettingByAreaObject[areaId].total += total
        billingSettingByAreaObject[areaId].data.push(billingSetting)
      }
    }
    for (let contract of contracts) {
      let products = [], customerName = '', customerId = '', customerTel = '', totalCost = 0, totalRecognizance = invoiceByContractObject[contract.objectId] ? invoiceByContractObject[contract.objectId] : 0
      if (contract.billingData) {
        customerName = contract.billingData.name
        customerTel = contract.billingData.tel
      }
      if (contract.customer) customerId = contract.customer.customerId
      if (contract.areas && contract.areas.length)
        for (const area of contract.areas) {
          if (area.objectId && billingSettingByAreaObject[area.objectId])
            totalCost += (billingSettingByAreaObject[area.objectId].total || 0)
          if (area.products && area.products.length)
            for (const product of area.products) {
              if (product && product.name)
                products.push(product.name)
            }
        }

      worksheet.addRow(
        {
          1: contract.market.name,
          2: contract.areas.map(d => d.name).sort().join(','),
          3: customerName,
          4: customerId,
          5: products.join(',') || '-',
          6: contract.businessName || '-',
          7: customerTel,
          8: totalRecognizance,
          9: contract.startDate.iso ? new Date(moment(contract.startDate.iso).format("YYYY-MM-DD")) : "",
          10: contract.endDate.iso ? new Date(moment(contract.endDate.iso).format("YYYY-MM-DD")) : "",
          11: contract.contractId,
          12: contract.totalCost,
        },
        { alignment: { horizontal: "center" } }
      );
    }

    const fileToDayDateTime = moment(new Date()).format("YYYYMMDDHHmmss");
    const newStartDate = moment(startDate).format("DD/MM/YYYY");
    const newEndDate = moment(endDate).format("DD/MM/YYYY");
    const formToDate = "from-" + newStartDate + "-to-" + newEndDate;
    // save excel
    if (isActiveContract) {
      return this.saveFile(
        workbook,
        "report-active-" + moment().format("DD/MM/YYYY")
      );
    } else {
      return this.saveFile(
        workbook,
        "report-checkin-" + formToDate + "-" + fileToDayDateTime
      );
    }
  }
  static async reportSuspend(dataSet, areas, startDate, endDate) {
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet(i18n.t('suspend.suspend_sale'));
    let columns = []
    let contractSuspends = []
    columns.push({
      header: dataSet[0].text,
      key: 1,
      width: 15,
      style: {
        alignment: {
          horizontal: "center",
          vertical: "center"
        }
      }
    })
    for (let [index, data] of dataSet.slice(1).entries()) {
      columns.push({
        header: new Date(moment(data.date).format("YYYY-MM-DD")),
        key: index + 2,
        width: 15,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      })
    }
    worksheet.columns = columns
    worksheet.getRow(1).font = { bold: true };
    for (let area of areas) {
      let obj = {}
      for (let [index, data] of dataSet.filter(d => d.type == "data").entries()) {
        if (data.hashContractSuspend[area.objectId]) {
          if (!data.hashAreaBooking[area.objectId]) {
            if (data.hashContractSuspend[area.objectId].type == 'late') {
              obj[index + 2] = i18n.t('market.late')
            } else {
              obj[index + 2] = i18n.t('market.absent')
            }
          } else {
            obj[index + 2] = "✔"
          }

          if (!contractSuspends.find(d => d.objectId == data.hashContractSuspend[area.objectId].objectId)) {
            contractSuspends.push(data.hashContractSuspend[area.objectId])
          }
        } else {
          if (
            data.hashContract[area.objectId] ||
            data.hashContractCheckout[area.objectId] ||
            data.hashAreaBooking[area.objectId]
          ) {
            obj[index + 2] = "✔"
          }
        }
      }
      worksheet.addRow(
        {
          1: area.name || "",
          ...obj
        }
      );
    }
    let lastDataRow = 1
    worksheet.eachRow(function (row, rowNumber) {
      lastDataRow = rowNumber
      row.eachCell(function (cell, colNumber) {
        if (cell.value == "✔") {
          row.getCell(colNumber).font = { color: { argb: "002196f3" } };
        } else if (cell.value == i18n.t('market.late')) {
          row.getCell(colNumber).font = { color: { argb: "00fbae43" } };
        } else if (cell.value == i18n.t('market.absent')) {
          row.getCell(colNumber).font = { color: { argb: "00eb5455" } };
        }
      });
    });
    let summaryLate = {}
    let summaryArea = {}
    let summaryAbsent = {}
    for (let [index, data] of dataSet.filter(d => d.type == "data").entries()) {
      summaryLate[index + 2] = data.late || 0
      summaryArea[index + 2] = data.summary || 0
      summaryAbsent[index + 2] = data.absent || 0
    }
    worksheet.addRow(
      {
        1: i18n.t('market.late'),
        ...summaryLate
      }
    );
    worksheet.addRow(
      {
        1: i18n.t('market.absent'),
        ...summaryAbsent
      }
    );
    worksheet.addRow(
      {
        1: i18n.t('sum'),
        ...summaryArea
      }
    );
    worksheet.getRow(++lastDataRow).font = { bold: true };
    worksheet.getRow(++lastDataRow).font = { bold: true };
    worksheet.getRow(++lastDataRow).font = { bold: true };
    worksheet.addRow()
    ++lastDataRow
    for (let contractSuspend of contractSuspends) {
      let txt = ""
      let areas = contractSuspend.contract.areas || []
      txt += `${i18n.t('area.space')} ` + (areas.map(d => d.name).join(",") || "-") + " "
      txt += contractSuspend.typeText + " "
      if (contractSuspend.isSuspend) {
        if (contractSuspend.cancelledDate) {
          txt += Math.floor(
            moment(contractSuspend.cancelledDate.iso)
              .diff(contractSuspend.startDate.iso, "day", true)
          ) + ` ${i18n.t('day')} `
        } else {
          txt += Math.ceil(
            moment(contractSuspend.endDate.iso)
              .diff(contractSuspend.startDate.iso, "day", true)
          ) + ` ${i18n.t('day')} `
        }
      }
      if (contractSuspend.detail) txt += contractSuspend.detail + " "
      if (contractSuspend.penaltyDetail) txt += contractSuspend.penaltyDetail + " "
      if (contractSuspend.note) txt += contractSuspend.note + " "
      worksheet.addRow(
        {
          2: txt,
        }
      );
      worksheet.getRow(++lastDataRow).alignment = { horizontal: "left" };
    }
    const fileToDayDateTime = moment(new Date()).format("YYYYMMDDHHmmss");
    const newStartDate = moment(startDate).format("DD/MM/YYYY");
    const newEndDate = moment(endDate).format("DD/MM/YYYY");
    const formToDate = "from-" + newStartDate + "-to-" + newEndDate;
    // save excel
    return this.saveFile(
      workbook,
      "report-suspend-" + formToDate + "-" + fileToDayDateTime
    );
  }

  static async reportContractWillExpire(contracts) {
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet("sheet1");
    worksheet.columns = [
      {
        header: i18n.t('contract.contract_number_only'),
        key: 1,
        width: 30,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('contract.business_name'),
        key: 2,
        width: 30,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('contract.contract_owner_name'),
        key: 3,
        width: 30,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.space'),
        key: 4,
        width: 30,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.stall_type'),
        key: 5,
        width: 20,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.title'),
        key: 6,
        width: 20,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('start_date'),
        key: 7,
        width: 30,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('end_date'),
        key: 8,
        width: 30,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('status'),
        key: 9,
        width: 30,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
    ]
    for(let contract of contracts){
      let row = worksheet.addRow({
        1: contract.contractId,
        2: contract.businessName,
        3: contract.customerFullName,
        4: contract.areasText,
        5: contract.stallType == "temporary" ? i18n.t('contact.stall_type.temporary') : i18n.t('contact.stall_type.regularly') ,
        6: contract.status.text,
        7: contract.startDate.iso ? new Date(moment(contract.startDate.iso).format("YYYY-MM-DD")) : "",
        8: contract.endDate.iso ? new Date(moment(contract.endDate.iso).format("YYYY-MM-DD")) : "",
        9: contract.ageExpireStatus.text
      })
      let hashColor = {
        error: "00eb5455",
        warning: "00fbae43",
        info: '00029ce5',
        success: '002ac770',
      }
      row.getCell(9).font = { color: { argb: hashColor[contract.ageExpireStatus.color] } };
      row.getCell(6).font = { color: { argb: contract.status.text == i18n.t('invoice.no_pending_invoice') ? "002ac770" : "00eb5455" } };
    }
    return this.saveFile(workbook, `report-will-expired-${moment().format("DDMMYYYY")}`);
  }
}
